import * as React from "react";
import Svg, { Path } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={props.size || 312}
    height={props.size || 304}
    viewBox="0 0 312 304"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M72.0205 85.7047C90.7471 72.9898 111.629 67.9396 134.103 65.4898C169.919 61.5857 210.881 44.0793 237.987 67.6133C266.847 92.6694 271.142 138.634 260.884 175.562C251.337 209.93 221.713 237.108 187.791 248.317C160.055 257.482 134.299 235.494 106.577 226.551C85.6598 219.804 62.0732 219.657 47.6609 203.115C32.0299 185.174 23.793 160.459 28.64 137.097C33.3646 114.325 52.7338 98.8 72.0205 85.7047Z"
      fill={props.bgColor || "#F6F9FF"}
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M190.236 60.1087C196.641 57.5332 199.746 50.253 197.17 43.8478C194.595 37.4427 187.315 34.3381 180.909 36.9136L132.411 56.4145C128.896 57.8278 126.212 60.759 125.112 64.3844C124.013 68.0098 124.617 71.9382 126.755 75.0658L153.753 114.565C157.649 120.264 165.428 121.726 171.127 117.831C176.826 113.935 178.288 106.157 174.393 100.457L166.109 88.3376C178.662 90.9123 187.478 95.5011 193.697 100.881C201.285 107.446 205.889 115.949 208.288 125.679C213.228 145.715 208.439 169.693 201.969 185.869C199.405 192.279 202.522 199.554 208.932 202.118C215.342 204.681 222.617 201.564 225.18 195.154C232.71 176.33 239.221 146.708 232.561 119.694C229.16 105.899 222.239 92.5151 210.052 81.9735C201.401 74.4897 190.543 68.824 177.318 65.3029L190.236 60.1087Z"
      fill={props.color1 || "#B8D2FF"}
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M109.666 247.344C103.261 249.92 100.157 257.2 102.732 263.605C105.307 270.01 112.588 273.115 118.993 270.54L167.491 251.039C171.006 249.625 173.691 246.694 174.79 243.069C175.89 239.443 175.285 235.515 173.148 232.387L146.149 192.888C142.253 187.189 134.475 185.727 128.775 189.623C123.076 193.518 121.614 201.297 125.51 206.996L133.794 219.116C121.241 216.541 112.425 211.952 106.206 206.572C98.6169 200.008 94.0131 191.504 91.6144 181.774C86.6745 161.738 91.4632 137.76 97.9338 121.584C100.498 115.174 97.38 107.899 90.9702 105.336C84.5604 102.772 77.2858 105.889 74.7219 112.299C67.1925 131.123 60.6811 160.745 67.3412 187.759C70.7425 201.554 77.6638 214.938 89.8499 225.48C98.5012 232.963 109.36 238.629 122.584 242.15L109.666 247.344Z"
      fill={props.color2 || "#D7F2DB"}
    />
  </Svg>
);
export default SVGComponent;
